import { render, staticRenderFns } from "./GridEmptyState.vue?vue&type=template&id=2097fab2"
import script from "./GridEmptyState.vue?vue&type=script&lang=js"
export * from "./GridEmptyState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports